module.exports = __webpack_public_path__ + "static/media/spinner-144x144px.66991839.gif";